import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Redirect, useLocation } from 'react-router-dom';
import Cookies from 'universal-cookie';
import PropTypes from 'prop-types';
import AccessSelector from './components/AccessSelector';
import 'react-toastify/dist/ReactToastify.css';
import { userActions } from '../../redux/actions/userActions';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const Login = ({ login, impersonateLogin }) => {
  const [loading, setLoading] = useState(false);
  const [redirect, setRedirect] = useState(false);
  const cookies = new Cookies();
  const query = useQuery();

  const userEmail = query.get('userEmail') || '';
  const adminEmail = query.get('adminEmail') || '';
  const impersonateType = query.get('type') || '';

  useEffect(() => {
    if (cookies.get('JWT') !== undefined) {
      setRedirect(true);
    }
  }, [cookies]);

  const handleSubmit = (values) => {
    setLoading(true);

    // Impersonate
    if (impersonateType && userEmail && adminEmail) {
      impersonateLogin(
        userEmail,
        values.password,
        values.rememberMe,
        impersonateType,
        adminEmail,
      )
        .then(() => setLoading(false))
        .catch(() => setLoading(false));
    } else {
      // Normal login
      login(
        values.email,
        values.password,
        values.rememberMe,
        values.accountType,
        'ew',
      )
        .then(() => setLoading(false))
        .catch(() => setLoading(false));
    }
  };

  if (redirect) {
    return <Redirect push to="/home" />;
  }

  return (
    <div className="account" style={{ flexDirection: 'column' }}>
      <AccessSelector
        handleSubmit={handleSubmit}
        loading={loading}
        userEmail={userEmail}
        adminEmail={adminEmail}
        impersonateType={impersonateType}
      />
    </div>
  );
};

Login.propTypes = {
  login: PropTypes.func.isRequired,
  impersonateLogin: PropTypes.func.isRequired,

};

const mapState = (state) => {
  const {
    loggingIn, codeLoggingIn, requestNewPassword, newPassword,
  } = state.authentication;
  return {
    loggingIn,
    codeLoggingIn,
    requestNewPassword,
    newPassword,
  };
};

const actionCreators = {
  login: userActions.loginGetUser,
  impersonateLogin: userActions.impersonateLogin,
  forgotPassword: userActions.forgotPassword,
  logout: userActions.logout,
};

export default connect(mapState, actionCreators)(Login);
